import React, { useEffect, useMemo, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { useNavigate } from "react-router-dom";
import api from "../Axios/api";
import Loader from "../common/Loader";
import { Eye } from "lucide-react";
const Report = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [month, setMonth] = useState("");
  const [isloading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [activeFactory, setActiveFactory] = useState(null);
  const columns = useMemo(
    () => [
      {
        accessorKey: "po_date",
        header: "Date",
        Cell: ({ cell }) =>
          new Intl.DateTimeFormat("en-GB").format(new Date(cell.getValue())),
      },

      {
        accessorKey: "party",
        header: "Party Name",
      },
      {
        accessorKey: "po_number",
        header: "PO Number",
      },
      {
        accessorKey: "purchase_qty",
        header: "Qty",
      },
    //  {
    //   accessorKey: "purchase_remaining_qty",
    //   header: "Remaining Qty",
    //   Cell: ({ cell }) => {
    //     const value = cell.getValue();
    //     const num = Number(value);
    //     return (Math.round((num + Number.EPSILON) * 100) / 100).toFixed(2);
    //   },
    // },
      {
        accessorKey: "status",
        header: "Status",
        Cell: ({ row }) => {
          const status = (row.original.status || "")
            .toString()
            .trim()
            .toLowerCase();
          const getColor = () => {
            if (status === "pending") return "bg-red-500 text-white";
            if (status === "partial") return "bg-gray-500 text-white";
            if (status === "received") return "bg-green-500 text-white";
            return "bg-gray-500 text-white";
          };

          return (
            <button className={`px-2 py-1 rounded ${getColor()} w-[80px]`}>
              {status.charAt(0).toUpperCase() + status.slice(1)}
            </button>
          );
        },
      },

      {
        accessorKey: "action",
        header: "Action",
        Cell: ({ row }) => (
          <div>
            <button
              className="text-blue-500 underline hover:text-blue-700 mr-5"
              onClick={() =>
                navigate("/summary-details", { state: row.original })
              }
            >
              {" "}
              <Eye size={20} />
            </button>
          </div>
        ),
      },
    ],
    [month]
  );
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const res = await api.get(`/summary-report/get?month=${month}`);
      const sortedData = res.data.data.sort(
        (a, b) =>
          new Date(b.po_date) -
          new Date(a.po_date)
      );
      setData(sortedData);
      setFilteredData(sortedData);
      // console.log(sortedData);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [month]);

    const handleFilter = (factoryId) => {
    setActiveFactory(factoryId);
    if (!factoryId) {
      setFilteredData(data);
    } else {
      setFilteredData(data.filter((item) => item.branch === factoryId));
    }
  };

  useEffect(() => {
    const now = new Date();
    const year = now.getFullYear();
    const monthNum = String(now.getMonth() + 1).padStart(2, "0");
    const currentMonth = `${year}-${monthNum}`;
    setMonth(currentMonth);
  }, []);

  return (
    <div className="p-6">
      <div className="flex flex-row items-center justify-between bg-white p-3 mb-3 rounded-lg">
        <h1 className="text-2xl font-bold mb-0 text-gray-800">
          {" "}
          Summary Report
        </h1>
        <div className="mb-4 space-x-2">
          <input
            type="month"
            value={month}
            onChange={(e) => {
              setMonth(e.target.value);
            }}
            className="border rounded px-2 py-1"
          />
        </div>
      </div>
       <div className="mb-4 space-x-2 ">
          <button
            className={`px-3 py-1 rounded ${
              activeFactory === null ? "bg-blue-600 text-white" : "bg-gray-300"
            }`}
            onClick={() => handleFilter(null)}
          >
            All
          </button>
          <button
            className={`px-3 py-1 rounded ${
              activeFactory === "666c0f5ebeca5ab2c65b2c85"
                ? "bg-blue-600 text-white"
                : "bg-gray-300"
            }`}
            onClick={() => handleFilter("666c0f5ebeca5ab2c65b2c85")}
          >
            INSULATION
          </button>
          <button
            className={`px-3 py-1 rounded ${
              activeFactory === "666c0f5ebeca5ab2c65b2c86"
                ? "bg-blue-600 text-white"
                : "bg-gray-300"
            }`}
            onClick={() => handleFilter("666c0f5ebeca5ab2c65b2c86")}
          >
            PROJECTS
          </button>
          <button
            className={`px-3 py-1 rounded ${
              activeFactory === "666c0f5ebeca5ab2c65b2c87"
                ? "bg-blue-600 text-white"
                : "bg-gray-300"
            }`}
            onClick={() => handleFilter("666c0f5ebeca5ab2c65b2c87")}
          >
            ROCKFIBRE
          </button>
        </div>

      {/* Table */}
      {isloading ? (
        <Loader />
      ) : (
        <MaterialReactTable
          columns={columns}
          data={filteredData}
          enablePagination
          enableBottomToolbar
          muiTableBodyRowProps={{
            hover: true,
          }}
        />
      )}
    </div>
  );
};

export default Report;
